import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { toast } from "sonner";
import { submitLead } from "../../lib/api";
import { Field, inputCls, Honeypot } from "./fields";
import { CTAButton } from "../common/CTAButton";

const schema = z.object({
    name: z.string().min(2, "Enter your name"),
    email: z.string().email("Enter a valid email"),
    mobile: z.string().optional(),
    subject: z.string().optional(),
    message: z.string().min(5, "Enter your message"),
    honeypot: z.string().optional(),
});

export const ContactForm = () => {
    const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({ resolver: zodResolver(schema) });

    const onSubmit = async (values) => {
        try {
            await submitLead("contact", values);
            toast.success("Message sent. We'll get back to you soon.");
            reset();
        } catch (e) {
            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} data-testid="contact-form" className="space-y-5">
            <Honeypot register={register} />
            <div className="grid sm:grid-cols-2 gap-5">
                <Field label="Name" required error={errors.name?.message}>
                    <input className={inputCls} placeholder="Your name" data-testid="ct-name" {...register("name")} />
                </Field>
                <Field label="Email" required error={errors.email?.message}>
                    <input className={inputCls} placeholder="name@company.com" data-testid="ct-email" {...register("email")} />
                </Field>
                <Field label="Mobile Number">
                    <input className={inputCls} placeholder="+91" data-testid="ct-mobile" {...register("mobile")} />
                </Field>
                <Field label="Subject">
                    <input className={inputCls} placeholder="How can we help?" data-testid="ct-subject" {...register("subject")} />
                </Field>
            </div>
            <Field label="Message" required error={errors.message?.message}>
                <textarea rows={5} className={inputCls} placeholder="Write your message" data-testid="ct-message" {...register("message")} />
            </Field>
            <CTAButton type="submit" variant="primary" arrow disabled={isSubmitting} data-testid="ct-submit" className="w-full sm:w-auto disabled:opacity-60">
                {isSubmitting ? "Sending..." : "Send Message"}
            </CTAButton>
        </form>
    );
};
